export const CREATE_PAYMENT_PLAN = 'CREATE_PAYMENT_PLAN';
export const CREATE_PAYMENT_PLAN_REQUEST = 'CREATE_PAYMENT_PLAN_REQUEST';
export const CREATE_PAYMENT_PLAN_SUCCESS = 'CREATE_PAYMENT_PLAN_SUCCESS';
export const CREATE_PAYMENT_PLAN_FAILURE = 'CREATE_PAYMENT_PLAN_FAILURE';

export const EXECUTE_PAYMENT_PLAN = 'EXECUTE_PAYMENT_PLAN';
export const EXECUTE_PAYMENT_PLAN_REQUEST = 'EXECUTE_PAYMENT_PLAN_REQUEST';
export const EXECUTE_PAYMENT_PLAN_SUCCESS = 'EXECUTE_PAYMENT_PLAN_SUCCESS';
export const EXECUTE_PAYMENT_PLAN_FAILURE = 'EXECUTE_PAYMENT_PLAN_FAILURE';

export const ADD_ADDRESS = 'ADD_ADDRESS';
export const ADD_ADDRESS_REQUEST = 'ADD_ADDRESS_REQUEST';
export const ADD_ADDRESS_SUCCESS = 'ADD_ADDRESS_SUCCESS';
export const ADD_ADDRESS_FAILURE = 'ADD_ADDRESS_FAILURE';

export const ADD_PAYMENT_CARD = 'ADD_PAYMENT_CARD';

export const DISMISS_ERRORS = 'DISMISS_ERRORS';
